// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Registration_wrapper__3600F","content":"Registration_content__3qs-d","img":"Registration_img__3mevU"};